<template>
  <v-dialog v-model="dialog" max-width="600px" @click:outside="close">
    <v-card>
      <v-card-title>{{ $t('tslOrders.columnConfiguration') }}</v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item v-for="(column, index) in columns" :key="column.key">
            <v-list-item-action>
              <v-checkbox
                v-model="column.visible"
                :disabled="column.mandatory"
                hide-details
              />
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ column.label }}</v-list-item-title>
              <v-list-item-subtitle v-if="column.mandatory">
                {{ $t('tslOrders.mandatoryColumn') }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn
                icon
                small
                @click="moveUp(index)"
                :disabled="index === 0"
              >
                <v-icon>mdi-arrow-up</v-icon>
              </v-btn>
            </v-list-item-action>
            <v-list-item-action>
              <v-btn
                icon
                small
                @click="moveDown(index)"
                :disabled="index === columns.length - 1"
              >
                <v-icon>mdi-arrow-down</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="resetToDefault">{{ $t('tslOrders.resetToDefault') }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn text @click="close">{{ $t('common.cancel') }}</v-btn>
        <v-btn color="primary" @click="save">{{ $t('common.save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ColumnConfigDialog',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    currentConfig: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      columns: []
    }
  },
  computed: {
    dialog: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    value (newVal) {
      if (newVal) {
        this.loadColumns()
      }
    }
  },
  methods: {
    loadColumns () {
      if (this.currentConfig && this.currentConfig.length > 0) {
        this.columns = JSON.parse(JSON.stringify(this.currentConfig))
      } else {
        this.columns = this.getDefaultColumns()
      }
    },
    getDefaultColumns () {
      return [
        // Kolumny obowiązkowe
        { key: 'createdAt', label: this.$t('tslOrders.createdAt'), visible: true, mandatory: true },
        { key: 'orderNumber', label: this.$t('tslOrders.orderNumber'), visible: true, mandatory: true },

        // Kolumny domyślne (widoczne)
        { key: 'loadingPlace', label: this.$t('tslOrders.loadingPlace'), visible: true, mandatory: false },
        { key: 'loadingDate', label: this.$t('tslOrders.loadingDate'), visible: true, mandatory: false },
        { key: 'unloadingPlace', label: this.$t('tslOrders.unloadingPlace'), visible: true, mandatory: false },
        { key: 'unloadingDate', label: this.$t('tslOrders.unloadingDate'), visible: true, mandatory: false },
        { key: 'clientContractorName', label: this.$t('tslOrders.clientName'), visible: true, mandatory: false },
        { key: 'carrierContractorName', label: this.$t('tslOrders.carrierName'), visible: true, mandatory: false },
        { key: 'clientPriceWithCurrency', label: this.$t('tslOrders.clientPriceWithCurrency'), visible: true, mandatory: false },
        { key: 'carrierPriceWithCurrency', label: this.$t('tslOrders.carrierPriceWithCurrency'), visible: true, mandatory: false },
        { key: 'commission', label: this.$t('tslOrders.commission'), visible: true, mandatory: false },

        // Kolumny dodatkowe (niewidoczne domyślnie)
        { key: 'clientPhone', label: this.$t('tslOrders.clientPhone'), visible: false, mandatory: false },
        { key: 'clientEmail', label: this.$t('tslOrders.clientEmail'), visible: false, mandatory: false },
        { key: 'clientRefNumber', label: this.$t('tslOrders.fields.clientRefNumber'), visible: false, mandatory: false },
        { key: 'driverFullName', label: this.$t('tslOrders.driverFullName'), visible: false, mandatory: false },
        { key: 'carrierPhone', label: this.$t('tslOrders.fields.carrierPhone'), visible: false, mandatory: false },
        { key: 'vehicleRegistrationNumber', label: this.$t('tslOrders.vehicleRegistrationNumber'), visible: false, mandatory: false },
        { key: 'carrierVehicleType', label: this.$t('tslOrders.vehicleType'), visible: false, mandatory: false },
        { key: 'createdByUserName', label: this.$t('tslOrders.assignedEmployee'), visible: false, mandatory: false }
      ]
    },
    moveUp (index) {
      if (index > 0) {
        const temp = this.columns[index]
        this.$set(this.columns, index, this.columns[index - 1])
        this.$set(this.columns, index - 1, temp)
      }
    },
    moveDown (index) {
      if (index < this.columns.length - 1) {
        const temp = this.columns[index]
        this.$set(this.columns, index, this.columns[index + 1])
        this.$set(this.columns, index + 1, temp)
      }
    },
    resetToDefault () {
      this.columns = this.getDefaultColumns()
    },
    save () {
      this.$emit('save', this.columns)
      this.close()
    },
    close () {
      this.$emit('input', false)
    }
  }
}
</script>

<style scoped>
.v-list-item {
  min-height: 56px;
}
</style>
